import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteSettingsContext = createContext({ settings: null, reload: () => {} });

const asText = (value) => (value == null ? "" : String(value));

const normalizeContactList = (value, fallbackLabel) => (
  Array.isArray(value)
    ? value
      .filter((entry) => entry && (typeof entry === "string" || typeof entry === "object"))
      .map((entry) => (typeof entry === "string"
        ? { label: fallbackLabel, value: entry, visible: true }
        : { label: asText(entry.label) || fallbackLabel, value: asText(entry.value), visible: entry.visible !== false }))
      .filter((entry) => entry.value)
    : []
);

const normalizeSocialLinks = (value) => (
  Array.isArray(value)
    ? value
      .filter((entry) => entry && typeof entry === "object")
      .map((entry) => ({
        platform: asText(entry.platform),
        label: asText(entry.label) || asText(entry.platform),
        url: asText(entry.url),
        visible: entry.visible !== false,
      }))
      .filter((entry) => entry.url)
    : []
);

const normalizeSettings = (value) => {
  const source = value && typeof value === "object" ? value : {};
  const phones = normalizeContactList(source.phones, "Téléphone");
  const emails = normalizeContactList(source.emails, "E-mail");
  const whatsapps = normalizeContactList(source.whatsapps, "WhatsApp");
  if (!phones.length && asText(source.phone)) phones.push({ label: "Téléphone principal", value: asText(source.phone), visible: true });
  if (!emails.length && asText(source.email)) emails.push({ label: "E-mail principal", value: asText(source.email), visible: true });
  if (!whatsapps.length && asText(source.whatsapp)) whatsapps.push({ label: "WhatsApp principal", value: asText(source.whatsapp), visible: true });
  return {
    ...source,
    phone: asText(source.phone),
    email: asText(source.email),
    whatsapp: asText(source.whatsapp),
    address: asText(source.address),
    phones,
    emails,
    whatsapps,
    hours: asText(source.hours),
    maps_url: asText(source.maps_url),
    website_url: asText(source.website_url),
    contact_note: asText(source.contact_note),
    social_links: normalizeSocialLinks(source.social_links),
    portal_visibility: { property_enabled:true, auto_enabled:true, hospitality_enabled:true, spaces_enabled:true, services_enabled:true, business_enabled:false, business_invest_enabled:true, business_sell_enabled:true, business_fundraise_enabled:true, ...(source.portal_visibility || {}) },
  };
};

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const load = () => {
    api.get("/settings/site")
      .then((r) => setSettings(normalizeSettings(r.data)))
      .catch(() => setSettings(normalizeSettings({})));
  };

  useEffect(() => { load(); }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings: settings || {}, reload: load }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
